import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('./views/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ai',
    name: 'ai',
    component: () => import('./views/ai.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ai/delete',
    name: 'ai-delete',
    component: () => import('./views/ai/delete.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ai/post/zufang',
    name: 'ai-post-zufang',
    component: () => import('./views/ai/post-zufang.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/map/:type',
    name: 'map',
    component: () => import('./views/map.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/search',
    name: 'search',
    component: () => import('./views/search.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/poster',
    name: 'poster',
    component: () => import('./views/poster.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/computer',
    name: 'computer',
    component: () => import('./views/computer.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/ershoufang',
    name: 'ershoufang',
    component: () => import('./views/ershoufang/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/person',
    name: 'person',
    component: () => import('./views/ershoufang/person.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/diy/:id',
    name: 'diy',
    component: () => import('./views/ershoufang/diy.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/house/yuyue/:id',
    name: 'yuyue',
    component: () => import('./views/house/yuyue.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/house',
    name: 'house',
    component: () => import('./views/house/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/house/view/:id',
    name: 'houseview',
    component: () => import('./views/house/view.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/shop',
    name: 'shop',
    component: () => import('./views/shop/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/shop/view/:id',
    name: 'shopview',
    component: () => import('./views/shop/view.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/shop/list/:id',
    name: 'shoplist',
    component: () => import('./views/shop/list.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zufang',
    name: 'zufang',
    component: () => import('./views/zufang/index.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ershoufang/vr/:id',
    name: 'vr',
    component: () => import('./views/ershoufang/vr.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zufang/list/:id',
    name: 'zufanglist',
    component: () => import('./views/zufang/list.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/ershoufang/list/:id',
    name: 'ershoufanglist',
    component: () => import('./views/ershoufang/list.vue'),
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/zufang/view/:id',
    name: 'zufangview',
    component: () => import('./views/zufang/view.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/ershoufang/view/:id',
    name: 'ershoufangview',
    component: () => import('./views/ershoufang/view.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user',
    name: 'user',
    component: () => import('./views/user/general/index.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/user/edit',
    name: 'useredit',
    component: () => import('./views/user/edit.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/edit/zufang/:id',
    name: 'usereditzufang',
    component: () => import('./views/user/edit/zufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/edit/ershoufang/:id',
    name: 'usereditershoufang',
    component: () => import('./views/user/edit/ershoufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/edit/shop/:id',
    name: 'usereditshop',
    component: () => import('./views/user/edit/shop.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/agent',
    name: 'useragent',
    component: () => import('./views/user/general/index.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/agent/vip/:id',
    name: 'useragent',
    component: () => import('./views/user/vip/vip.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/house',
    name: 'userhouse',
    component: () => import('./views/user/house.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/refresh/:id/:type',
    name: 'userrefreshid',
    component: () => import('./views/user/refresh.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/sticky/:id/:type',
    name: 'userstickyid',
    component: () => import('./views/user/sticky.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/jishou/:id/:type',
    name: 'userjishouid',
    component: () => import('./views/user/jishou.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/view',
    name: 'userview',
    component: () => import('./views/user/view.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/zhifu/:id',
    name: 'zhifuid',
    component: () => import('./views/user/zhifu.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/apply',
    name: 'userapply',
    component: () => import('./views/user/general/apply.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/bind/:id',
    name: 'userbind',
    component: () => import('./views/user/bind.vue'),
    meta: {
      keepAlive: false
    }
  },
 
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/user/login.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/zufang',
    name: 'postzufang',
    component: () => import('./views/post/zufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/shop',
    name: 'postshop',
    component: () => import('./views/post/shop.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/jingjiren',
    name: 'postjingjiren',
    component: () => import('./views/post/jingjiren.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/jingjiren/:id',
    name: 'postjingjirenid',
    component: () => import('./views/post/jingjiren.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/house/:id',
    name: 'posthouse',
    component: () => import('./views/post/house.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/post/ershoufang',
    name: 'postershoufang',
    component: () => import('./views/post/ershoufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/qiuzu',
    name: 'posterqiuzu',
    component: () => import('./views/post/qiuzu.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/qiugou',
    name: 'posterqiugou',
    component: () => import('./views/post/qiugou.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/zhifu/:id/:type',
    name: 'posterzhifu',
    component: () => import('./views/post/zhifu.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/post/sticky/:id/:type',
    name: 'postersticky',
    component: () => import('./views/post/sticky.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/agent',
    name: 'agent',
    component: () => import('./views/agent/index.vue'),
    meta: {
      keepAlive: false
    }
  },

  {
    path: '/agent/:id',
    name: 'agentid',
    component: () => import('./views/agent/view.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/agent/list/1',
    name: 'agentlist',
    component: () => import('./views/agent/list.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/favor',
    name: 'favor',
    component: () => import('./views/user/general/favor.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/order',
    name: 'order',
    component: () => import('./views/user/general/order.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/zufang',
    name: 'userzufang',
    component: () => import('./views/user/general/myzufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/ershoufang',
    name: 'userershoufang',
    component: () => import('./views/user/general/myershoufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/general/tuoguan',
    name: 'usergeneraltuoguan',
    component: () => import('./views/user/general/tuoguan.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/general/nopay',
    name: 'usergeneraltuoguan',
    component: () => import('./views/user/general/nopay.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/vip/tuoguan',
    name: 'userviptuoguan',
    component: () => import('./views/user/vip/tuoguan.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/shop',
    name: 'userershop',
    component: () => import('./views/user/general/myshop.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/agent/zufang',
    name: 'useragentzufang',
    component: () => import('./views/user/vip/myzufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/agent/ershoufang',
    name: 'useragentershoufang',
    component: () => import('./views/user/vip/myershoufang.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/agent/shop',
    name: 'useragentshop',
    component: () => import('./views/user/vip/myshop.vue'),
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/user/agent/statistics',
    name: 'useragentstatistics',
    component: () => import('./views/user/vip/statistics.vue'),
    meta: {
      keepAlive: false
    }

  }




];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

export {
  router
};
